// extracted by mini-css-extract-plugin
export default {"StartMenu":"StartMenu_StartMenu__ZcI17","StartMenu__VerticalBar":"StartMenu_StartMenu__VerticalBar__lViQe","StartMenu__MenuItems":"StartMenu_StartMenu__MenuItems__Oe-47"};